export default __webpack_public_path__ + "static/Metal_Water_Reservoir-51b577871ff01b2573775bcd6011940b.png";